const PLACEHOLDER = "https://placehold.co/260x160/1a1a1a/ff0033?text=Video";

const VideoRow = ({ title, videos = [], onPlay }) => {
  if (!videos.length) return null;
console.log("Rendering VideoRow with videos:", videos);
  return (
    <div className="mb-5">
      <h3 className="mb-3">{title}</h3>

      <div className="d-flex overflow-auto gap-3 pb-2">
        {videos.map((video) => (
          <div
            key={video.id}
            style={{ minWidth: "260px", cursor: "pointer", flexShrink: 0 }}
            className="card shadow-sm"
            onClick={() => onPlay(video)}
          >
            <div style={{ position: "relative", background: "#111" }}>
            
              <img
                src={video.thumbnail || PLACEHOLDER}
                className="card-img-top"
                alt={video.title}
                style={{ height: "160px", objectFit: "cover", display: "block", width: "100%" }}
                onError={(e) => { e.currentTarget.src = PLACEHOLDER; }}
              />
              {/* play icon overlay */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: 0,
                  transition: "opacity 0.2s",
                }}
                className="video-play-overlay"
              >
                <i
                  className="fa fa-play-circle"
                  style={{ fontSize: "48px", color: "#fff", filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.8))" }}
                />
              </div>
            </div>

            <div className="card-body py-2 px-3">
              <h6 className="mb-0" style={{ fontSize: "13px", lineHeight: "1.4" }}>{video.title}</h6>
              {video.duration_seconds > 0 && (
                <small className="text-muted">{formatDuration(video.duration_seconds)}</small>
              )}
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .card:hover .video-play-overlay { opacity: 1 !important; }
        .card:hover { transform: translateY(-2px); transition: transform 0.2s; }
      `}</style>
    </div>
  );
};

const formatDuration = (seconds) => {
  if (!seconds) return "";
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
};

export default VideoRow;
